import { HTMLAttributes, ReactNode, forwardRef } from "react";
import { cn } from "@/lib/utils";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  children: ReactNode;
  variant?: "default" | "primary" | "secondary" | "success" | "warning" | "danger" | "outline";
  size?: "sm" | "md" | "lg";
}

export const Badge = forwardRef<HTMLSpanElement, BadgeProps>(
  ({ children, variant = "default", size = "md", className, ...props }, ref) => {
    const baseClasses =
      "inline-flex items-center gap-1 font-medium rounded-full transition-colors";

    const variantClasses = {
      default:
        "bg-muted text-muted-foreground",
      primary:
        "bg-honey text-bee-black",
      secondary:
        "bg-honey-dark text-white",
      success:
        "bg-success text-success-foreground",
      warning:
        "bg-warning text-warning-foreground",
      danger:
        "bg-destructive text-destructive-foreground",
      outline:
        "border-2 border-honey text-foreground bg-transparent",
    };

    const sizeClasses = {
      sm: "px-2 py-0.5 text-xs",
      md: "px-2.5 py-1 text-sm",
      lg: "px-3 py-1.5 text-base",
    };

    return (
      <span
        ref={ref}
        className={cn(
          baseClasses,
          variantClasses[variant],
          sizeClasses[size],
          className
        )}
        {...props}
      >
        {children}
      </span>
    );
  }
);

Badge.displayName = "Badge";

